module.exports = __webpack_public_path__ + "img/correct-data.aec602b0.png";